module.exports = __webpack_public_path__ + "img/badge-dollar.7c6dbc66.svg";